import type { CreateOffer } from '@ooh/contracts';
import type { QuickAddOfferPickerConfirmArgs } from '../quick-add-offer-picker';

/**
 * Maps a `QuickAddOfferPickerConfirmArgs` (`mode: 'creating'`) payload into the
 * `CreateOffer` shape expected by `POST /offers`. Shared by `useCalendarOfferPicker`
 * (apps/web) and `useQuickAddPipeline`, so a new field cannot drift between the two.
 */
export function buildCreateOfferPayload(
  args: Pick<
    QuickAddOfferPickerConfirmArgs,
    'clientId' | 'salespersonId' | 'brand' | 'defaultDateFrom' | 'defaultDateTo'
  >,
): Pick<CreateOffer, 'clientId'> &
  Partial<Pick<CreateOffer, 'salespersonId' | 'brand' | 'defaultDateFrom' | 'defaultDateTo'>> {
  return {
    clientId: Number(args.clientId),
    ...(args.salespersonId != null ? { salespersonId: args.salespersonId } : {}),
    ...(args.brand ? { brand: args.brand } : {}),
    ...(args.defaultDateFrom ? { defaultDateFrom: args.defaultDateFrom } : {}),
    ...(args.defaultDateTo ? { defaultDateTo: args.defaultDateTo } : {}),
  };
}
